import { BaseRequest } from '@trukt/types/BaseRequest';
import { AxiosInstance } from 'axios';

type BodyShape = { orders: (string | number)[] };

export type DeleteCargoTelOrdersRequest = BaseRequest<void, BodyShape>;
export type DeleteCargoTelOrdersResponse = void;

export type SyncCargoTelOrdersRequest = BaseRequest<void, BodyShape>;
export type SyncCargoTelOrdersResponse = void;

export class CargoTelService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  sync({ body }: SyncCargoTelOrdersRequest) {
    return this.instance.post<SyncCargoTelOrdersResponse>('/cargotel/sync', body);
  }

  delete({ body }: DeleteCargoTelOrdersRequest) {
    return this.instance.delete<DeleteCargoTelOrdersResponse>('/cargotel/sync', {
      data: body,
    });
  }
}
